import { render } from "./UnpaidWork.vue?vue&type=template&id=7de18760&scoped=true"
import script from "./UnpaidWork.vue?vue&type=script&lang=js"
export * from "./UnpaidWork.vue?vue&type=script&lang=js"

import "./UnpaidWork.vue?vue&type=style&index=0&id=7de18760&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de18760"]])

export default __exports__